<template>
  <div id="validacao-de-minuta" class="validacao-de-minuta">
    <div
      class="container_medio container_com-fundo container_com-margem u-padding-grande"
    >
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <div class="grade__linha grade__linha_alinhar-vertical-ao-topo">
        <div class="grade__coluna grade__coluna_3">
          <div class="titulo titulo_grande u-margem-inferior-media">
            Validação de minuta
          </div>
          <div class="data-situacao u-margem-inferior-media">
            <span>Data da aprovação: </span>
            <span v-if="this.dataDeAprovacao">{{
              $tempo.formatarParaPadraoBrasileiro(this.dataDeAprovacao)
            }}</span>
          </div>
        </div>
        <div class="grade__coluna grade__coluna_9">
          <div
            class="u-nao-imprimir grade__linha grade__linha_alinhar-horizontal-direita"
          >
            <button
              type="button"
              :disabled="minutaDoCertificadoFoiValidada"
              class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-direita-media"
              @click="abrirModalDeAprovacao"
            >
              Aprovar
            </button>
            <button
              type="button"
              :disabled="minutaDoCertificadoFoiValidada"
              class="no-print botao botao_cor-terciaria botao_com-icone-para-esquerda botao_contorno botao_sem-preenchimento botao_medio u-margem-inferior-grande"
              @click="abrirModalDeReprovacao"
            >
              Reprovar
            </button>
          </div>
        </div>
        <div class="grade__coluna grade__coluna_12">
          <div class="pdf-container">
            <embed :src="pdfUrl" type="application/pdf" width="100%" height="100%" />
          </div>
        </div>
      </div>
      <modal v-if="modalDeAprovacaoEstaVisivel" @close="fecharModalDeAprovacao">
        <form @submit.prevent="aprovarMinuta">
          <h3 class="titulo titulo_medio u-margem-inferior-media">Aprovar minuta</h3>
          <hr class="u-margem-inferior-media" />
          <div>
            <p class="mensagem-confirmacao u-margem-inferior-grande">
              <strong>Tem certeza que deseja aprovar essa minuta?</strong>
            </p>
          </div>
          <div class="grade__linha_alinhar-horizontal-direita formulario-button">
            <button
              type="button"
              @click="fecharModalDeAprovacao"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :class="{ 'is-loading': loading.visivel }"
            >
              Confirmar
            </button>
          </div>
        </form>
      </modal>
      <modal v-if="modalDeReprovacaoEstaVisivel" @close="fecharModalDeReprovacao">
        <form @submit.prevent="reprovarMinuta" class="formulario">
          <h3 class="titulo titulo_medio u-margem-inferior-media">Reprovar minuta</h3>
          <hr class="u-margem-inferior-media" />
          <label for="justificativa">Motivo da reprovação</label>
          <textarea
            v-model="justificativaDaReprovacao"
            name="justificativa"
            id="justificativa"
            cols="30"
            rows="8"
            class="input u-margem-inferior-media"
            placeholder="Descreva aqui o motivo detalhadamente"
            required
          ></textarea>
          <div class="grade__linha_alinhar-horizontal-direita formulario-button">
            <button
              type="button"
              @click="fecharModalDeReprovacao"
              class="botao botao_cinza botao_medio u-margem-direita-pequena"
            >
              Cancelar
            </button>
            <button
              type="submit"
              class="botao botao_cor-terciaria botao_medio"
              :disabled="!justificativaDaReprovacaoEstaPreenchida"
              :class="{ 'is-loading': loading.visivel }"
            >
              Confirmar
            </button>
          </div>
        </form>
      </modal>
      <MensagemFlutuante
        :mensagemVisivel="mensagemVisivel"
        :titulo="tituloMensagem"
        :estilo="estiloMensagem"
        :texto="textoMensagem"
        @close="fecharMensagem"
      />
    </div>
  </div>
</template>

<script>
import Loading from "../../shared/Loading";
import Modal from "../../shared/Modal";
import MensagemFlutuante from "../../shared/MensagemFlutuante";

export default {
  name: "validacao-de-minuta",
  components: { Loading, Modal, MensagemFlutuante },
  computed: {
    justificativaDaReprovacaoEstaPreenchida() {
      return (
        this.justificativaDaReprovacao != null &&
        this.justificativaDaReprovacao.length > 0
      );
    },
  },
  created() {
    this.carregarSolicitacao();
  },
  beforeDestroy() {
    if (this.pdfUrl) URL.revokeObjectURL(this.pdfUrl);

    if (this.timeoutId) clearTimeout(this.timeoutId);
  },
  data() {
    return {
      dataDeAprovacao: null,
      pdfUrl: null,
      loading: { visivel: true },
      modalDeReprovacaoEstaVisivel: false,
      modalDeAprovacaoEstaVisivel: false,
      justificativaDaReprovacao: null,
      minutaDoCertificadoFoiValidada: false,
      mensagemVisivel: false,
      textoMensagem: "",
      estiloMensagem: "",
      tituloMensagem: "",
    };
  },
  methods: {
    carregarSolicitacao() {
      let idDaSolicitacao = this.$route.query.idDaSolicitacao;
      this.exibirCarregamento();

      this.$api
        .get(`/solicitacao/${idDaSolicitacao}`)
        .then((response) => {
          this.dataDeAprovacao = response.data.DataDeAprovacao;
          this.obterMinutaDoCertificado();
        })
        .catch((error) => {
          this.tratarErro(error);
          this.esconderCarregamento();
        });
    },
    obterMinutaDoCertificado() {
      let idDaSolicitacao = this.$route.query.idDaSolicitacao;
      let url = `/ValidacaoDeMinuta/${idDaSolicitacao}/ObterMinutaDoCertificado`;

      this.$api
        .getArraybuffer(url)
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" });
          this.pdfUrl = URL.createObjectURL(blob);
        })
        .catch(() => {
          let mensagem =
            "Não foi possível obter a minuta, tente novamente ou contate o suporte";
          this.exibirMensagemDeErro(mensagem);
        })
        .finally(() => {
          this.esconderCarregamento();
        });
    },
    aprovarMinuta() {
      let url = "ValidacaoDeMinuta/AprovarMinutaDoCertificado";
      let parametrosParaAprovacaoDaMinutaDoCertificado = {
        SolicitacaoId: this.$route.query.idDaSolicitacao,
      };

      this.exibirCarregamento();
      this.$api
        .post(url, parametrosParaAprovacaoDaMinutaDoCertificado)
        .then(() => {
          let mensagemDeSucesso = this.obterMensagemDeAprovacaoDaMinuta();
          this.exibirMensagemDeSucesso(mensagemDeSucesso);
          this.minutaDoCertificadoFoiValidada = true;
          this.timeoutId = setTimeout(() => this.redirecionarParaListagem(), 10000);
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.esconderCarregamento();
          this.fecharModalDeAprovacao();
        });
    },
    reprovarMinuta() {
      let url = "ValidacaoDeMinuta/ReprovarMinutaDoCertificado";
      let parametrosParaReprovacaoDaMinutaDoCertificado = {
        SolicitacaoId: this.$route.query.idDaSolicitacao,
        Observacao: this.justificativaDaReprovacao,
      };

      this.exibirCarregamento();
      this.$api
        .post(url, parametrosParaReprovacaoDaMinutaDoCertificado)
        .then(() => {
          let mensagemDeSucesso = this.obterMensagemDeReprovacaoDaMinuta();
          this.exibirMensagemDeSucesso(mensagemDeSucesso);
          this.minutaDoCertificadoFoiValidada = true;
          this.timeoutId = setTimeout(() => this.redirecionarParaListagem(), 10000);
        })
        .catch((error) => {
          this.tratarErro(error);
        })
        .finally(() => {
          this.esconderCarregamento();
          this.fecharModalDeReprovacao();
        });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    abrirModalDeReprovacao() {
      this.modalDeReprovacaoEstaVisivel = true;
    },
    fecharModalDeReprovacao() {
      this.modalDeReprovacaoEstaVisivel = false;
    },
    abrirModalDeAprovacao() {
      this.modalDeAprovacaoEstaVisivel = true;
    },
    fecharModalDeAprovacao() {
      this.modalDeAprovacaoEstaVisivel = false;
    },
    tratarErro(error) {
      const mensagensDeErro = error.response.data.Message;
      let mensagem;

      if (mensagensDeErro) mensagem = mensagensDeErro.split(",").join("<br />");
      else
        mensagem =
          "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";

      this.exibirMensagemDeErro(mensagem);
    },
    exibirMensagemDeSucesso(mensagem) {
      let estiloDaMensagem = "sucesso";
      let tituloDaMensagem = "Concluído";
      this.exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem);
    },
    exibirMensagemDeErro(mensagem) {
      let estiloDaMensagem = "erro";
      this.exibirMensagem(mensagem, estiloDaMensagem);
    },
    exibirMensagem(mensagem, estiloDaMensagem, tituloDaMensagem) {
      this.mensagemVisivel = true;
      this.textoMensagem = mensagem;
      this.estiloMensagem = estiloDaMensagem;
      this.tituloMensagem = tituloDaMensagem || "";
      setTimeout(() => {
        this.fecharMensagem();
      }, 10000);
    },
    fecharMensagem() {
      this.mensagemVisivel = false;
    },
    redirecionarParaListagem() {
      this.$router.push({ name: "ListaDeValidacaoDeMinutas" });
    },
    obterMensagemDeAprovacaoDaMinuta() {
      return "Minuta aprovada com sucesso! A AGEHAB será notificada, irá gerar o certificado, realizar assinatura e disponibilizar para impressão em breve.";
    },
    obterMensagemDeReprovacaoDaMinuta() {
      return "Minuta reprovada com sucesso! O correspondente bancário será notificado para realizar o ajuste da informação conforme descrito na justificativa.";
    },
  },
};
</script>



// WEBPACK FOOTER //
// ValidacaoDeMinuta.vue?3c79c604